module.exports = __webpack_public_path__ + "assets/58732011c49f8107f26a67a2b1c8fc9e.png";